$.extend($.validator.messages, {
	required: trans('fgsz.forms.required'),
	maxlength: $.validator.format("Legfeljebb {0} karakter hosszú legyen."),
	minlength: $.validator.format("Legalább {0} karakter hosszú legyen."),
	rangelength: $.validator.format("Legalább {0} és legfeljebb {1} karakter hosszú legyen."),
	email: trans('fgsz.forms.email'),
	url: trans('fgsz.forms.url'),
	date: trans('fgsz.forms.date'),
	number: trans('fgsz.forms.number'),
	digits: trans('fgsz.forms.digits'),
	equalTo: trans('fgsz.forms.equalTo'),
	range: $.validator.format("{0} és {1} közé kell esnie."),
	max: $.validator.format("Nem lehet nagyobb, mint {0}."),
	min: $.validator.format("Nem lehet kisebb, mint {0}."),
	creditcard: "Érvényes hitelkártyaszámnak kell lennie.",
	remote: trans('fgsz.forms.remote'),
	dateISO: trans('fgsz.forms.dateISO'),
});

$.validator.setDefaults({
	ignore: []
});

var Form = function () {

	var loaderStart = function (form) {
		$(form).addClass('loading');
	};

	var loaderStop = function () {
		$('.cms-form').removeClass('loading');
	};

	var initFormValidation = function () {
		$.validator.addMethod(
			"regex",
			function (value, element, regexp) {
				var re = new RegExp(regexp);
				return this.optional(element) || re.test(value);
			},
			"Please check your input."
		);

		$('.cms-form').each(function () {
			$(this).validate({
				focusInvalid: true, // do not focus the last invalid input
				errorElement: 'span',
				validClass: 'is-valid',
				errorClass: 'is-invalid',

				errorPlacement: function (error, element) {
					error.addClass('invalid-tooltip');
					element.closest('.form-group').append(error);
				},
				highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass(validClass);
                    $(element).closest('.form-group').addClass(errorClass);
				},
				unhighlight: function (element, errorClass, validClass) {
					$(element).removeClass(errorClass);
					$(element).addClass(validClass);
				},
                success: function (label) {
                    label.closest('.form-group').removeClass('is-invalid');
                    label.closest('.form-group').removeClass('is-valid');
                    label.remove();
                },
				submitHandler: function (form) {
					ajaxSubmit(form);
				}
			});

			$(this).find('input[type="file"]').each(function () {
                $(this).rules("add", {
                    fileType: {
                        types: ["pdf", "txt", "text/plain", "doc", "docx"]
                    },
                    maxFileSize: {
                        "unit": "MB",
                        "size": 2
                    },
                });
            });
		});


		$('[data-phone-field]').each(function () {
			$(this).rules("add", {
				regex: /^(((\+)|(00))[0-9]{8,14})|(06[0-9]{1,2}[0-9]{6,7})$/,
				messages: {
					regex: trans('fgsz.forms.phone'),
				}
			});
		});
	};

	var ajaxSubmit = function (form) {
		loaderStart(form);

        $('#error-message').addClass('d-none');

		$(form).ajaxSubmit({
			success: function (response) {
				setTimeout(() => {
					$(form).fadeOut("slow", function () {
						$(this).replaceWith(response.html);
						$(this).fadeIn("slow");
					});

                    loaderStop();
                }, 200);
			},
			error: function (response) {
                console.log(3);
                const errors = response.responseJSON.errors;
                let errorMessage = trans('fgsz.forms.errorMessage');

			    if (typeof errors === 'object' && errors !== null) {
                    errorMessage = errors[Object.keys(errors)[0]];
                } else if (typeof errors === 'string' || errors instanceof String) {
                    errorMessage = errors;
                }

                $('#error-message').text(errorMessage);
                $('#error-message').removeClass('d-none');
                loaderStop();
            },
		});
	};

	var initFields = function () {
		$('input[type="file"]').on('change', function () {
			//get the file name
			var fileName = $(this).val().replace("C:\\fakepath\\", "");
			//replace the "Choose a file" label
			$(this).next('.custom-file-label').html(fileName);
		});
    };

	var getErrors = function (rErrors) {
		var errors = [];

		for (var propertyName in rErrors) {

			var messages = rErrors[propertyName];

			for (var msg in messages) {
				errors.push({
					'msg': messages[msg]
				});
			}
		}

		const markup = `<ul class="mb-0">${errors.map(error => `<li>${error.msg} </li>`).join('')}</ul>`;

		return markup;
	};


	return {
		//main function to initiate the module
		init: function () {
			initFields();
			initFormValidation();
		}
	};
}();


$(document).ready(function () {
	window.Form = Form;
	window.Form.init();
});
